import { render, staticRenderFns } from "./supply-chain_h5.vue?vue&type=template&id=8a57cd82&scoped=true&"
import script from "./supply-chain_h5.vue?vue&type=script&lang=js&"
export * from "./supply-chain_h5.vue?vue&type=script&lang=js&"
import style0 from "./supply-chain_h5.vue?vue&type=style&index=0&id=8a57cd82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a57cd82",
  null
  
)

export default component.exports